var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SvgIcon } from '@mui/material';
export const DzAiIcon = (_a) => {
    var props = __rest(_a, []);
    return (_jsx(SvgIcon, Object.assign({}, props, { children: _jsxs("svg", Object.assign({ width: "26", height: "26", viewBox: "0 0 26 26", fill: "none" }, { children: [_jsx("rect", { width: "24", height: "24", rx: "4", fill: "currentColor" }), _jsx("text", Object.assign({ x: "4", y: "18", fill: "#fff", fontSize: "16", fontWeight: "bold" }, { children: "AI" }))] })) })));
};
